interface FlowSuccessData {
  selectedPlanTitle: string
  formattedPremium: string
  priceLabel: string
  formattedStartDate: string
}

const storageKey = (flowName: string) => `gs_success_data:${flowName}`

export const resolveFlowSuccessData = ({
  flowName,
  current,
  hasPrice,
  emptyPremium,
}: {
  flowName: string
  current: FlowSuccessData
  hasPrice: boolean
  emptyPremium: string
}): FlowSuccessData => {
  if (typeof window === 'undefined') {
    return current
  }

  const key = storageKey(flowName)

  if (hasPrice) {
    sessionStorage.setItem(key, JSON.stringify(current))
  }

  const saved = (() => {
    try {
      return JSON.parse(sessionStorage.getItem(key) ?? '{}') as Partial<FlowSuccessData>
    } catch {
      return {} as Partial<FlowSuccessData>
    }
  })()

  return {
    selectedPlanTitle: saved.selectedPlanTitle || current.selectedPlanTitle,
    formattedPremium:
      saved.formattedPremium && saved.formattedPremium !== emptyPremium
        ? saved.formattedPremium
        : current.formattedPremium,
    priceLabel: saved.priceLabel || current.priceLabel,
    formattedStartDate: saved.formattedStartDate || current.formattedStartDate,
  }
}
